import React, { memo } from 'react';
import PageHeader from '../components/layout/PageHeader';
import Gallery from '../components/ui/Gallery';
import Tabs from '../components/ui/Tabs';
import Button from '../components/ui/Button';
import { HomeIcon, UtensilsIcon, BedIcon, ShieldIcon, HeartIcon, UsersIcon, BookOpenIcon, MusicIcon, AwardIcon, CalendarIcon, ArrowRightIcon, ClockIcon, CheckIcon, MapPinIcon, ZapIcon, UserIcon, PaletteIcon, GlobeIcon, CpuIcon, MessageSquareIcon } from 'lucide-react';
const StudentLife = () => {
  const galleryImages = [{
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8M2i6Lt61u8AiKMZqhL6Xz/WhatsApp_Image_2025-10-24_at_10.01.22.jpg',
    alt: 'Cultural performance',
    caption: 'Students performing traditional cultural dance'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3DHAcubmTqmT13YpTTNQmr/WhatsApp_Image_2025-10-24_at_10.01.24.jpg',
    alt: 'Morning assembly',
    caption: 'Students at morning assembly'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mMF9fzVCb1rew9Z9Ba8RBR/WhatsApp_Image_2025-10-24_at_11.30.12.jpg',
    alt: 'School grounds',
    caption: 'Beautiful school grounds with pathways'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3iuYwPBfNvbAqWiL5UGdQD/WhatsApp_Image_2025-08-14_at_15.45.35_%283%29.jpg',
    alt: 'Students in classroom',
    caption: 'Students in their classroom'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tXB2gESgQyPW5hZWnwiFvU/WhatsApp_Image_2025-08-08_at_06.35.51_%281%29.jpg',
    alt: 'Student in uniform',
    caption: 'Student in front of the Chemistry Laboratory'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5gKYWryVTvwM3jPw4Bpnok/WhatsApp_Image_2025-10-24_at_10.01.16.jpg',
    alt: 'Chemistry laboratory',
    caption: 'Students conducting chemistry experiments'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ez9ThFy3DkQ6XwMpYtSRNQ/WhatsApp_Image_2025-10-24_at_10.01.16.jpg',
    alt: 'Students in laboratory',
    caption: 'Students engaged in practical science experiments'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rYxE1D1a3w1zMFiLJm2aU1/WhatsApp_Image_2025-10-24_at_10.01.17.jpg',
    alt: 'Chemistry lesson',
    caption: 'Interactive chemistry lesson in progress'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kMX4mMRKhHUYMbFhqjEMu9/WhatsApp_Image_2025-10-24_at_10.01.20_%281%29.jpg',
    alt: 'Biology lesson',
    caption: 'Biology teacher demonstrating with anatomical models'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/f2xgFc9rK22wZyJ7XvkYdc/WhatsApp_Image_2025-10-24_at_10.01.18.jpg',
    alt: 'Female cricket team',
    caption: 'IGS Girls Cricket Team with their coaches'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fqznuuu78HmKmW8bRuWFw1/WhatsApp_Image_2025-10-24_at_10.01.19.jpg',
    alt: 'Football training',
    caption: 'Students during football training session'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fhbXs7UNN6d2HJRiEebjre/WhatsApp_Image_2025-10-24_at_10.01.20.jpg',
    alt: 'Students in classroom',
    caption: 'Students attentively listening to their teacher during class'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/aeofuDDq4R4LzKTTb7kCTJ/WhatsApp_Image_2025-10-24_at_10.01.21.jpg',
    alt: 'Teacher with students in classroom',
    caption: 'Teacher engaging with students in a traditional classroom setting'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/26CHK6sEK66nfVUNdvbwf4/WhatsApp_Image_2025-10-24_at_10.01.20_%282%29.jpg',
    alt: 'Physics lesson with technology',
    caption: 'Teacher demonstrating wave mechanics using digital technology'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fBcdZe3j5kT56auYSAwRFV/WhatsApp_Image_2025-10-24_at_10.01.23_%281%29.jpg',
    alt: 'Mathematics teacher',
    caption: 'Teacher explaining advanced mathematics concepts on the whiteboard'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3GFAKQjjuFe5vR4bv8XoiJ/WhatsApp_Image_2025-10-24_at_10.01.21_%281%29.jpg',
    alt: 'Computer lab session',
    caption: 'Students learning in the modern computer laboratory'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vKv5s2R4J3htwPZBqsE5mu/WhatsApp_Image_2025-10-24_at_10.01.23.jpg',
    alt: 'Teacher teaching students in classroom',
    caption: 'Female teacher in traditional attire engaging students in an active learning session'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8v7HegjxEmi2KSxNec1Zxz/WhatsApp_Image_2025-10-24_at_10.01.25.jpg',
    alt: 'Sports team on field',
    caption: 'School sports team ready for competition on the field'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hWx5tyEVbwQVrxum4dtVj3/WhatsApp_Image_2025-10-24_at_13.20.17_%281%29.jpg',
    alt: 'Students in science laboratory',
    caption: 'Students conducting experiments in the modern science laboratory'
  }];
  const testimonials = [{
    name: 'Oluwaseun Adebayo',
    role: 'Current Student, SS3',
    quote: "The boarding experience at IGS has taught me independence and discipline. The facilities are excellent, and the house parents are caring and supportive. I've made lifelong friends here.",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3DHAcubmTqmT13YpTTNQmr/WhatsApp_Image_2025-10-24_at_10.01.24.jpg'
  }, {
    name: 'Chioma Nwosu',
    role: 'Current Student, SS2',
    quote: "I love the balance between academics and extracurricular activities at IGS. The sports facilities are amazing, and I've been able to develop my talent in basketball while maintaining good grades.",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tXB2gESgQyPW5hZWnwiFvU/WhatsApp_Image_2025-08-08_at_06.35.51_%281%29.jpg'
  }, {
    name: 'Mrs. Adebola Johnson',
    role: 'Parent',
    quote: "The transformation in my son since joining IGS has been remarkable. The school's holistic approach to education, combining academic rigor with character development, is exactly what we were looking for.",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3iuYwPBfNvbAqWiL5UGdQD/WhatsApp_Image_2025-08-14_at_15.45.35_%283%29.jpg'
  }];
  const upcomingEvents = [{
    name: 'Inter-House Sports Competition',
    date: 'November 15, 2024',
    time: '9:00 AM',
    location: 'School Sports Ground',
    description: 'Annual sports competition featuring track and field events, team sports, and individual competitions.'
  }, {
    name: 'Cultural Day Celebration',
    date: 'December 10, 2024',
    time: '10:00 AM',
    location: 'School Hall',
    description: "A colorful celebration of Nigeria's diverse cultures featuring traditional dances, attire, and cuisine."
  }, {
    name: 'Christmas Carol Service',
    date: 'December 18, 2024',
    time: '4:00 PM',
    location: 'School Chapel',
    description: 'Annual carol service featuring performances by the school choir and drama group.'
  }, {
    name: 'Science & Technology Fair',
    date: 'February 20, 2025',
    time: '9:00 AM',
    location: 'School Hall',
    description: 'Exhibition of student projects in science, technology, engineering, and mathematics.'
  }];
  return <div className="min-h-screen bg-white" data-id="element-6577">
      <PageHeader title="Student Life at IGS" description="Experience the vibrant and balanced life of students at Isonyin Grammar School, where education extends beyond the classroom." backgroundImage="https://uploadthingy.s3.us-west-1.amazonaws.com/jdfoyTCXLviMyjmi5MDX1X/WhatsApp_Image_2025-10-24_at_11.30.13.jpg" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: 'Student Life',
      path: '/student-life'
    }]} data-id="element-6578" />
      <div className="container mx-auto px-4 py-12" data-id="element-6579">
        {/* Introduction Section */}
        <section className="mb-16" data-id="element-6580">
          <div className="text-center mb-10" data-id="element-6581">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-6582">
              Life at Isonyin Grammar School
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-6583"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-6584">
              At IGS, we provide a nurturing environment where students can grow
              academically, socially, and morally. Our balanced approach ensures
              that students enjoy a rich and fulfilling school experience.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-6585">
            <div data-id="element-6586">
              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-6587">
                Student life at Isonyin Grammar School is vibrant and dynamic,
                offering a perfect balance of academic rigor and extracurricular
                activities. We believe that education extends beyond the
                classroom, and our comprehensive approach focuses on developing
                the whole student.
              </p>
              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-6588">
                Whether as day students or boarders, our students benefit from a
                structured environment that promotes discipline, responsibility,
                and independence. The strong sense of community and camaraderie
                among students creates lifelong friendships and a supportive
                network.
              </p>
              <p className="text-gray-700 leading-relaxed" data-id="element-6589">
                From sports competitions to cultural celebrations, from
                community service to leadership opportunities, IGS offers
                numerous avenues for students to discover and develop their
                talents and interests.
              </p>
            </div>
            <Gallery images={galleryImages} columns={2} gap="medium" rounded={true} className="overflow-hidden rounded-lg shadow-md" data-id="element-6590" />
          </div>
        </section>
        {/* Boarding Life Section */}
        <section className="mb-16" id="boarding" data-id="element-6591">
          <div className="text-center mb-10" data-id="element-6592">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-6593">
              Boarding Life
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-6594"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-6595">
              Our boarding facilities provide a home away from home for
              students, fostering independence, discipline, and lifelong
              friendships.
            </p>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-6596">
            <div className="lg:col-span-2" data-id="element-6597">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4jLMnmKXSAWwavqGR8zdhM/WhatsApp_Image_2025-10-24_at_11.30.13_%281%29.jpg" alt="Boarding facilities" className="w-full h-96 object-cover rounded-lg shadow-md mb-6" data-id="element-6598" />
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-6599">
                <div className="bg-blue-50 p-6 rounded-lg" data-id="element-6600">
                  <div className="flex items-center mb-4" data-id="element-6601">
                    <HomeIcon className="h-6 w-6 text-blue-700 mr-3" data-id="element-6602" />
                    <h3 className="text-xl font-bold text-blue-900" data-id="element-6603">
                      Dormitories
                    </h3>
                  </div>
                  <p className="text-gray-700" data-id="element-6604">
                    Our dormitories are designed to provide comfort, privacy,
                    and a conducive environment for rest and study. Each
                    dormitory houses students of the same gender and similar age
                    groups, supervised by experienced house parents.
                  </p>
                </div>
                <div className="bg-blue-50 p-6 rounded-lg" data-id="element-6605">
                  <div className="flex items-center mb-4" data-id="element-6606">
                    <UtensilsIcon className="h-6 w-6 text-blue-700 mr-3" data-id="element-6607" />
                    <h3 className="text-xl font-bold text-blue-900" data-id="element-6608">Dining</h3>
                  </div>
                  <p className="text-gray-700" data-id="element-6609">
                    Our dining hall serves nutritious and balanced meals three
                    times daily, with provisions for special dietary needs. The
                    menu is varied and includes local and continental dishes
                    prepared by trained catering staff.
                  </p>
                </div>
                <div className="bg-blue-50 p-6 rounded-lg" data-id="element-6610">
                  <div className="flex items-center mb-4" data-id="element-6611">
                    <ShieldIcon className="h-6 w-6 text-blue-700 mr-3" data-id="element-6612" />
                    <h3 className="text-xl font-bold text-blue-900" data-id="element-6613">
                      Safety & Security
                    </h3>
                  </div>
                  <p className="text-gray-700" data-id="element-6614">
                    The safety and security of our students is paramount. Our
                    campus is secured with perimeter fencing, 24-hour security
                    personnel, and CCTV surveillance. Regular safety drills are
                    conducted.
                  </p>
                </div>
                <div className="bg-blue-50 p-6 rounded-lg" data-id="element-6615">
                  <div className="flex items-center mb-4" data-id="element-6616">
                    <HeartIcon className="h-6 w-6 text-blue-700 mr-3" data-id="element-6617" />
                    <h3 className="text-xl font-bold text-blue-900" data-id="element-6618">
                      Health Services
                    </h3>
                  </div>
                  <p className="text-gray-700" data-id="element-6619">
                    Our on-campus clinic is staffed by qualified healthcare
                    professionals who provide routine and emergency medical
                    care. For specialized care, we have partnerships with nearby
                    hospitals.
                  </p>
                </div>
              </div>
              <h3 className="text-xl font-bold text-blue-900 mb-4" data-id="element-6620">
                Daily Routine for Boarders
              </h3>
              <div className="overflow-x-auto" data-id="element-6621">
                <table className="min-w-full bg-white border border-gray-200 rounded-lg" data-id="element-6622">
                  <thead data-id="element-6623">
                    <tr className="bg-blue-900 text-white" data-id="element-6624">
                      <th className="py-2 px-4 text-left" data-id="element-6625">Time</th>
                      <th className="py-2 px-4 text-left" data-id="element-6626">Activity</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200" data-id="element-6627">
                    <tr className="bg-white hover:bg-gray-50" data-id="element-6628">
                      <td className="py-2 px-4 font-medium" data-id="element-6629">5:30 AM</td>
                      <td className="py-2 px-4" data-id="element-6630">Wake up</td>
                    </tr>
                    <tr className="bg-gray-50 hover:bg-gray-100" data-id="element-6631">
                      <td className="py-2 px-4 font-medium" data-id="element-6632">
                        5:30 AM - 6:30 AM
                      </td>
                      <td className="py-2 px-4" data-id="element-6633">
                        Morning preparation (bath, chores)
                      </td>
                    </tr>
                    <tr className="bg-white hover:bg-gray-50" data-id="element-6634">
                      <td className="py-2 px-4 font-medium" data-id="element-6635">
                        6:30 AM - 7:15 AM
                      </td>
                      <td className="py-2 px-4" data-id="element-6636">Breakfast</td>
                    </tr>
                    <tr className="bg-gray-50 hover:bg-gray-100" data-id="element-6637">
                      <td className="py-2 px-4 font-medium" data-id="element-6638">
                        7:45 AM - 3:30 PM
                      </td>
                      <td className="py-2 px-4" data-id="element-6639">School hours</td>
                    </tr>
                    <tr className="bg-white hover:bg-gray-50" data-id="element-6640">
                      <td className="py-2 px-4 font-medium" data-id="element-6641">
                        3:30 PM - 4:30 PM
                      </td>
                      <td className="py-2 px-4" data-id="element-6642">Extracurricular activities</td>
                    </tr>
                    <tr className="bg-gray-50 hover:bg-gray-100" data-id="element-6643">
                      <td className="py-2 px-4 font-medium" data-id="element-6644">
                        4:30 PM - 5:30 PM
                      </td>
                      <td className="py-2 px-4" data-id="element-6645">Free time / Rest</td>
                    </tr>
                    <tr className="bg-white hover:bg-gray-50" data-id="element-6646">
                      <td className="py-2 px-4 font-medium" data-id="element-6647">
                        5:30 PM - 6:30 PM
                      </td>
                      <td className="py-2 px-4" data-id="element-6648">Dinner</td>
                    </tr>
                    <tr className="bg-gray-50 hover:bg-gray-100" data-id="element-6649">
                      <td className="py-2 px-4 font-medium" data-id="element-6650">
                        7:00 PM - 9:00 PM
                      </td>
                      <td className="py-2 px-4" data-id="element-6651">
                        Evening prep (supervised study)
                      </td>
                    </tr>
                    <tr className="bg-white hover:bg-gray-50" data-id="element-6652">
                      <td className="py-2 px-4 font-medium" data-id="element-6653">
                        9:00 PM - 9:30 PM
                      </td>
                      <td className="py-2 px-4" data-id="element-6654">Evening devotion</td>
                    </tr>
                    <tr className="bg-gray-50 hover:bg-gray-100" data-id="element-6655">
                      <td className="py-2 px-4 font-medium" data-id="element-6656">
                        9:30 PM / 10:00 PM
                      </td>
                      <td className="py-2 px-4" data-id="element-6657">Lights out (JSS / SS)</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div data-id="element-6658">
              <div className="bg-blue-900 text-white p-6 rounded-lg mb-6" data-id="element-6659">
                <div className="flex items-center mb-4" data-id="element-6660">
                  <BedIcon className="h-6 w-6 text-yellow-400 mr-3" data-id="element-6661" />
                  <h3 className="text-xl font-bold" data-id="element-6662">Boarding Facilities</h3>
                </div>
                <ul className="space-y-3" data-id="element-6663">
                  <li className="flex items-start" data-id="element-6664">
                    <div className="flex-shrink-0 h-5 w-5 text-yellow-400 mr-2" data-id="element-6665">
                      ✓
                    </div>
                    <p data-id="element-6666">Separate dormitories for boys and girls</p>
                  </li>
                  <li className="flex items-start" data-id="element-6667">
                    <div className="flex-shrink-0 h-5 w-5 text-yellow-400 mr-2" data-id="element-6668">
                      ✓
                    </div>
                    <p data-id="element-6669">Comfortable bunk beds with storage space</p>
                  </li>
                  <li className="flex items-start" data-id="element-6670">
                    <div className="flex-shrink-0 h-5 w-5 text-yellow-400 mr-2" data-id="element-6671">
                      ✓
                    </div>
                    <p data-id="element-6672">Modern bathroom facilities</p>
                  </li>
                  <li className="flex items-start" data-id="element-6673">
                    <div className="flex-shrink-0 h-5 w-5 text-yellow-400 mr-2" data-id="element-6674">
                      ✓
                    </div>
                    <p data-id="element-6675">Common rooms with recreational facilities</p>
                  </li>
                  <li className="flex items-start" data-id="element-6676">
                    <div className="flex-shrink-0 h-5 w-5 text-yellow-400 mr-2" data-id="element-6677">
                      ✓
                    </div>
                    <p data-id="element-6678">Study areas with adequate lighting</p>
                  </li>
                  <li className="flex items-start" data-id="element-6679">
                    <div className="flex-shrink-0 h-5 w-5 text-yellow-400 mr-2" data-id="element-6680">
                      ✓
                    </div>
                    <p data-id="element-6681">Laundry services</p>
                  </li>
                  <li className="flex items-start" data-id="element-6682">
                    <div className="flex-shrink-0 h-5 w-5 text-yellow-400 mr-2" data-id="element-6683">
                      ✓
                    </div>
                    <p data-id="element-6684">24-hour security and supervision</p>
                  </li>
                </ul>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-6685">
                <div className="flex items-center mb-4" data-id="element-6686">
                  <UsersIcon className="h-6 w-6 text-blue-700 mr-3" data-id="element-6687" />
                  <h3 className="text-xl font-bold text-blue-900" data-id="element-6688">
                    House System
                  </h3>
                </div>
                <p className="text-gray-700 mb-4" data-id="element-6689">
                  Boarders are organized into houses, each named after notable
                  Nigerian educational pioneers:
                </p>
                <ul className="space-y-3 text-gray-700" data-id="element-6690">
                  <li className="flex items-start" data-id="element-6691">
                    <div className="w-4 h-4 rounded-full bg-red-500 mt-1 mr-2" data-id="element-6692"></div>
                    <p data-id="element-6693">
                      <strong data-id="element-6694">Ransome-Kuti House</strong> (Red)
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-6695">
                    <div className="w-4 h-4 rounded-full bg-blue-500 mt-1 mr-2" data-id="element-6696"></div>
                    <p data-id="element-6697">
                      <strong data-id="element-6698">Awolowo House</strong> (Blue)
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-6699">
                    <div className="w-4 h-4 rounded-full bg-green-500 mt-1 mr-2" data-id="element-6700"></div>
                    <p data-id="element-6701">
                      <strong data-id="element-6702">Azikiwe House</strong> (Green)
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-6703">
                    <div className="w-4 h-4 rounded-full bg-yellow-500 mt-1 mr-2" data-id="element-6704"></div>
                    <p data-id="element-6705">
                      <strong data-id="element-6706">Bello House</strong> (Yellow)
                    </p>
                  </li>
                </ul>
                <p className="mt-4 text-gray-700" data-id="element-6707">
                  Each house competes in academic, sports, and cultural
                  activities throughout the year, fostering a sense of
                  belonging, teamwork, and healthy competition.
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* Arts & Culture Section */}
        <section className="mb-16" id="arts" data-id="element-6708">
          <div className="text-center mb-10" data-id="element-6709">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-6710">
              Arts & Culture
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-6711"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-6712">
              We celebrate creativity and cultural expression through our arts
              programs, traditional performances, and cultural events throughout
              the year.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-12" data-id="element-6713">
            <div className="relative" data-id="element-6714">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8M2i6Lt61u8AiKMZqhL6Xz/WhatsApp_Image_2025-10-24_at_10.01.22.jpg" alt="Cultural performance" className="w-full h-96 object-cover rounded-lg shadow-md" data-id="element-6715" />
              <div className="absolute bottom-4 right-4 bg-blue-900 text-white p-3 rounded-lg shadow-lg" data-id="element-6716">
                <p className="font-bold" data-id="element-6717">Cultural Group</p>
                <p className="text-sm" data-id="element-6718">Traditional Dance Performance</p>
              </div>
            </div>
            <div data-id="element-6719">
              <h3 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-6720">
                Cultural Heritage
              </h3>
              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-6721">
                Our cultural groups showcase the rich heritage of Nigeria
                through traditional dances, music, and performances. Students
                learn about their cultural roots while developing confidence and
                stage presence.
              </p>
              <ul className="space-y-3 mb-6" data-id="element-6722">
                <li className="flex items-start" data-id="element-6723">
                  <div className="flex-shrink-0 h-6 w-6 rounded-full bg-blue-100 flex items-center justify-center mr-2" data-id="element-6724">
                    <CheckIcon className="h-4 w-4 text-blue-700" data-id="element-6725" />
                  </div>
                  <span className="text-gray-700" data-id="element-6726">
                    Traditional dance and music groups
                  </span>
                </li>
                <li className="flex items-start" data-id="element-6727">
                  <div className="flex-shrink-0 h-6 w-6 rounded-full bg-blue-100 flex items-center justify-center mr-2" data-id="element-6728">
                    <CheckIcon className="h-4 w-4 text-blue-700" data-id="element-6729" />
                  </div>
                  <span className="text-gray-700" data-id="element-6730">
                    Cultural festivals and celebrations
                  </span>
                </li>
                <li className="flex items-start" data-id="element-6731">
                  <div className="flex-shrink-0 h-6 w-6 rounded-full bg-blue-100 flex items-center justify-center mr-2" data-id="element-6732">
                    <CheckIcon className="h-4 w-4 text-blue-700" data-id="element-6733" />
                  </div>
                  <span className="text-gray-700" data-id="element-6734">
                    Inter-school cultural competitions
                  </span>
                </li>
                <li className="flex items-start" data-id="element-6735">
                  <div className="flex-shrink-0 h-6 w-6 rounded-full bg-blue-100 flex items-center justify-center mr-2" data-id="element-6736">
                    <CheckIcon className="h-4 w-4 text-blue-700" data-id="element-6737" />
                  </div>
                  <span className="text-gray-700" data-id="element-6738">
                    Drama and theater productions
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </section>
        {/* Daily Life Section */}
        <section className="mb-16" data-id="element-6739">
          <div className="text-center mb-10" data-id="element-6740">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-6741">
              Daily Life at IGS
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-6742"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-6743">
              A typical day at Isonyin Grammar School is structured to balance
              academics, character development, and personal growth.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-6744">
            <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-6745">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3DHAcubmTqmT13YpTTNQmr/WhatsApp_Image_2025-10-24_at_10.01.24.jpg" alt="Morning assembly" className="w-full h-64 object-cover" data-id="element-6746" />
              <div className="p-6" data-id="element-6747">
                <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-6748">
                  Morning Assembly
                </h3>
                <p className="text-gray-700" data-id="element-6749">
                  Each day begins with morning assembly where students gather
                  for prayers, announcements, and motivational talks. This helps
                  instill discipline and unity among students.
                </p>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-6750">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vKv5s2R4J3htwPZBqsE5mu/WhatsApp_Image_2025-10-24_at_10.01.23.jpg" alt="Teacher teaching in classroom" className="w-full h-64 object-cover" data-id="element-6751" />
              <div className="p-6" data-id="element-6752">
                <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-6753">
                  Interactive Classroom Learning
                </h3>
                <p className="text-gray-700" data-id="element-6754">
                  Our experienced teachers, many in traditional attire, create
                  engaging learning environments where students actively
                  participate and develop critical thinking skills.
                </p>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-6755">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fhbXs7UNN6d2HJRiEebjre/WhatsApp_Image_2025-10-24_at_10.01.20.jpg" alt="Students in classroom" className="w-full h-64 object-cover" data-id="element-6756" />
              <div className="p-6" data-id="element-6757">
                <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-6758">
                  Engaged Learning Environment
                </h3>
                <p className="text-gray-700" data-id="element-6759">
                  Students are actively engaged in their lessons, with teachers
                  using various methods to ensure understanding and
                  participation from all students.
                </p>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-6760">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hWx5tyEVbwQVrxum4dtVj3/WhatsApp_Image_2025-10-24_at_13.20.17_%281%29.jpg" alt="Science laboratory practical" className="w-full h-64 object-cover" data-id="element-6761" />
              <div className="p-6" data-id="element-6762">
                <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-6763">
                  Hands-On Science Education
                </h3>
                <p className="text-gray-700" data-id="element-6764">
                  Students engage in practical science experiments in our
                  well-equipped laboratories, developing critical scientific
                  inquiry and research skills.
                </p>
              </div>
            </div>
          </div>
          {/* Computer Lab Section */}
          <div className="bg-gray-50 p-8 rounded-lg" data-id="element-6765">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-6766">
              <div data-id="element-6767">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3GFAKQjjuFe5vR4bv8XoiJ/WhatsApp_Image_2025-10-24_at_10.01.21_%281%29.jpg" alt="Students in computer laboratory" className="w-full rounded-lg shadow-lg" data-id="element-6768" />
              </div>
              <div data-id="element-6769">
                <h3 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-6770">
                  Digital Learning Environment
                </h3>
                <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-6771">
                  Our computer laboratory provides students with hands-on
                  experience in digital literacy, programming, and modern
                  technology applications. Under the guidance of experienced
                  instructors, students develop essential 21st-century skills.
                </p>
                <p className="text-gray-700 leading-relaxed" data-id="element-6772">
                  The lab is equipped with modern computers and software,
                  allowing students to work on projects, research, and develop
                  their technology skills in a supportive environment.
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* Sports & Recreation Section */}
        <section className="mb-16" id="sports" data-id="element-6773">
          <div className="text-center mb-10" data-id="element-6774">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-6775">
              Sports & Recreation
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-6776"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-6777">
              Physical education and sports are integral parts of our
              curriculum, promoting physical fitness, teamwork, and character
              development.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-12" data-id="element-6778">
            <div className="order-2 md:order-1" data-id="element-6779">
              <h3 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-6780">
                Sporting Excellence
              </h3>
              <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-6781">
                At IGS, we believe in the importance of physical education in
                developing well-rounded individuals. Our comprehensive sports
                program caters to various interests and abilities, allowing
                students to discover and develop their athletic talents.
              </p>
              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-6782">
                Regular physical education classes are complemented by
                competitive sports, with opportunities to participate in
                inter-house, inter-school, state, and national competitions. Our
                coaches are experienced professionals dedicated to nurturing
                talent and instilling the values of sportsmanship, discipline,
                and teamwork.
              </p>
              <div className="grid grid-cols-2 gap-4" data-id="element-6783">
                <div className="bg-blue-50 p-4 rounded-lg" data-id="element-6784">
                  <div className="flex items-center mb-2" data-id="element-6785">
                    <UsersIcon className="h-5 w-5 text-blue-700 mr-2" data-id="element-6786" />
                    <h4 className="font-bold text-blue-900" data-id="element-6787">Team Sports</h4>
                  </div>
                  <ul className="text-gray-700 text-sm space-y-1" data-id="element-6788">
                    <li data-id="element-6789">• Football</li>
                    <li data-id="element-6790">• Basketball</li>
                    <li data-id="element-6791">• Volleyball</li>
                    <li data-id="element-6792">• Cricket</li>
                  </ul>
                </div>
                <div className="bg-blue-50 p-4 rounded-lg" data-id="element-6793">
                  <div className="flex items-center mb-2" data-id="element-6794">
                    <ZapIcon className="h-5 w-5 text-blue-700 mr-2" data-id="element-6795" />
                    <h4 className="font-bold text-blue-900" data-id="element-6796">Track & Field</h4>
                  </div>
                  <ul className="text-gray-700 text-sm space-y-1" data-id="element-6797">
                    <li data-id="element-6798">• Sprints</li>
                    <li data-id="element-6799">• Long-distance running</li>
                    <li data-id="element-6800">• Jumps</li>
                    <li data-id="element-6801">• Throws</li>
                  </ul>
                </div>
                <div className="bg-blue-50 p-4 rounded-lg" data-id="element-6802">
                  <div className="flex items-center mb-2" data-id="element-6803">
                    <UserIcon className="h-5 w-5 text-blue-700 mr-2" data-id="element-6804" />
                    <h4 className="font-bold text-blue-900" data-id="element-6805">
                      Individual Sports
                    </h4>
                  </div>
                  <ul className="text-gray-700 text-sm space-y-1" data-id="element-6806">
                    <li data-id="element-6807">• Table Tennis</li>
                    <li data-id="element-6808">• Badminton</li>
                    <li data-id="element-6809">• Chess</li>
                    <li data-id="element-6810">• Swimming</li>
                  </ul>
                </div>
                <div className="bg-blue-50 p-4 rounded-lg" data-id="element-6811">
                  <div className="flex items-center mb-2" data-id="element-6812">
                    <MusicIcon className="h-5 w-5 text-blue-700 mr-2" data-id="element-6813" />
                    <h4 className="font-bold text-blue-900" data-id="element-6814">Recreational</h4>
                  </div>
                  <ul className="text-gray-700 text-sm space-y-1" data-id="element-6815">
                    <li data-id="element-6816">• Dance</li>
                    <li data-id="element-6817">• Aerobics</li>
                    <li data-id="element-6818">• Yoga</li>
                    <li data-id="element-6819">• Board games</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="order-1 md:order-2 relative" data-id="element-6820">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8v7HegjxEmi2KSxNec1Zxz/WhatsApp_Image_2025-10-24_at_10.01.25.jpg" alt="School sports team" className="w-full h-96 object-cover rounded-lg shadow-md" data-id="element-6821" />
              <div className="absolute bottom-4 right-4 bg-blue-900 text-white p-3 rounded-lg shadow-lg transform rotate-3" data-id="element-6822">
                <p className="font-bold" data-id="element-6823">IGS Sports Team</p>
                <p className="text-sm" data-id="element-6824">Ready for Competition</p>
              </div>
            </div>
          </div>
          <div className="mb-12" data-id="element-6825">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-6826">
              <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-6827">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8v7HegjxEmi2KSxNec1Zxz/WhatsApp_Image_2025-10-24_at_10.01.25.jpg" alt="Football team" className="w-full h-64 object-cover" data-id="element-6828" />
                <div className="p-6" data-id="element-6829">
                  <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-6830">
                    Football Team
                  </h3>
                  <p className="text-gray-700" data-id="element-6831">
                    Our football team has consistently excelled in inter-school
                    competitions, winning the state championship in 2022 and
                    reaching the finals multiple times.
                  </p>
                </div>
              </div>
              <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-6832">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9KTZ7HUP1wb7ieQ2CeaS6b/WhatsApp_Image_2025-10-24_at_10.01.18_%281%29.jpg" alt="Athletics team" className="w-full h-64 object-cover" data-id="element-6833" />
                <div className="p-6" data-id="element-6834">
                  <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-6835">
                    Athletics Team
                  </h3>
                  <p className="text-gray-700" data-id="element-6836">
                    Our athletics team represents the school with pride in track
                    and field events, consistently bringing home medals from
                    regional and national competitions.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Girls Sports Section */}
          <div className="mb-12 bg-gray-50 p-8 rounded-lg" data-id="element-6837">
            <div className="text-center mb-8" data-id="element-6838">
              <h3 className="text-2xl font-bold text-blue-900 mb-3" data-id="element-6839">
                Girls in Sports
              </h3>
              <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-6840"></div>
              <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-6841">
                We actively encourage and support female students in sports,
                providing equal opportunities and dedicated coaching
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-6842">
              <div data-id="element-6843">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/f2xgFc9rK22wZyJ7XvkYdc/WhatsApp_Image_2025-10-24_at_10.01.18.jpg" alt="IGS Girls Cricket Team" className="w-full rounded-lg shadow-lg" data-id="element-6844" />
              </div>
              <div data-id="element-6845">
                <h4 className="text-xl font-bold text-blue-900 mb-4" data-id="element-6846">
                  Girls Cricket Team
                </h4>
                <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-6847">
                  Our girls cricket team has made remarkable progress under the
                  guidance of dedicated coaches. The team participates in
                  inter-school competitions and has shown exceptional skill and
                  sportsmanship.
                </p>
                <p className="text-gray-700 leading-relaxed" data-id="element-6848">
                  We provide specialized training and equipment for female
                  athletes, ensuring they have every opportunity to excel in
                  their chosen sports. Our commitment to gender equality in
                  sports has resulted in outstanding performances by our female
                  students.
                </p>
              </div>
            </div>
          </div>
          {/* Football Training Section */}
          <div className="mb-12" data-id="element-6849">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-6850">
              <div className="order-2 md:order-1" data-id="element-6851">
                <h4 className="text-xl font-bold text-blue-900 mb-4" data-id="element-6852">
                  Regular Training Sessions
                </h4>
                <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-6853">
                  Our sports program includes regular training sessions on our
                  well-maintained sports fields. Students receive professional
                  coaching that focuses on skill development, teamwork, and
                  physical fitness.
                </p>
                <p className="text-gray-700 leading-relaxed" data-id="element-6854">
                  Training sessions are scheduled throughout the week, allowing
                  students to balance their academic commitments with their
                  passion for sports. Our coaches work individually with
                  students to help them reach their full potential.
                </p>
              </div>
              <div className="order-1 md:order-2" data-id="element-6855">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fqznuuu78HmKmW8bRuWFw1/WhatsApp_Image_2025-10-24_at_10.01.19.jpg" alt="Students during football training" className="w-full rounded-lg shadow-lg" data-id="element-6856" />
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-6857">
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-6858">
              <div className="flex items-center mb-4" data-id="element-6859">
                <div className="p-3 bg-blue-100 rounded-full mr-3" data-id="element-6860">
                  <AwardIcon className="h-6 w-6 text-blue-700" data-id="element-6861" />
                </div>
                <h3 className="text-xl font-bold text-blue-900" data-id="element-6862">
                  Sports Achievements
                </h3>
              </div>
              <ul className="space-y-3 text-gray-700" data-id="element-6863">
                <li className="flex items-start" data-id="element-6864">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-500 mr-2" data-id="element-6865">
                    ✓
                  </div>
                  <p data-id="element-6866">State Champions in Inter-School Football (2022)</p>
                </li>
                <li className="flex items-start" data-id="element-6867">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-500 mr-2" data-id="element-6868">
                    ✓
                  </div>
                  <p data-id="element-6869">
                    2nd Place in National School Athletics Championship (2023)
                  </p>
                </li>
                <li className="flex items-start" data-id="element-6870">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-500 mr-2" data-id="element-6871">
                    ✓
                  </div>
                  <p data-id="element-6872">Regional Table Tennis Champions (2022)</p>
                </li>
                <li className="flex items-start" data-id="element-6873">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-500 mr-2" data-id="element-6874">
                    ✓
                  </div>
                  <p data-id="element-6875">State Chess Competition Winners (2023)</p>
                </li>
              </ul>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-6876">
              <div className="flex items-center mb-4" data-id="element-6877">
                <div className="p-3 bg-blue-100 rounded-full mr-3" data-id="element-6878">
                  <BookOpenIcon className="h-6 w-6 text-blue-700" data-id="element-6879" />
                </div>
                <h3 className="text-xl font-bold text-blue-900" data-id="element-6880">
                  Sports Facilities
                </h3>
              </div>
              <ul className="space-y-3 text-gray-700" data-id="element-6881">
                <li className="flex items-start" data-id="element-6882">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-500 mr-2" data-id="element-6883">
                    ✓
                  </div>
                  <p data-id="element-6884">Standard football field with running track</p>
                </li>
                <li className="flex items-start" data-id="element-6885">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-500 mr-2" data-id="element-6886">
                    ✓
                  </div>
                  <p data-id="element-6887">Basketball and volleyball courts</p>
                </li>
                <li className="flex items-start" data-id="element-6888">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-500 mr-2" data-id="element-6889">
                    ✓
                  </div>
                  <p data-id="element-6890">Indoor sports hall for table tennis and badminton</p>
                </li>
                <li className="flex items-start" data-id="element-6891">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-500 mr-2" data-id="element-6892">
                    ✓
                  </div>
                  <p data-id="element-6893">Swimming pool (25m, 6 lanes)</p>
                </li>
              </ul>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-6894">
              <div className="flex items-center mb-4" data-id="element-6895">
                <div className="p-3 bg-blue-100 rounded-full mr-3" data-id="element-6896">
                  <CalendarIcon className="h-6 w-6 text-blue-700" data-id="element-6897" />
                </div>
                <h3 className="text-xl font-bold text-blue-900" data-id="element-6898">
                  Annual Sports Events
                </h3>
              </div>
              <ul className="space-y-3 text-gray-700" data-id="element-6899">
                <li className="flex items-start" data-id="element-6900">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-500 mr-2" data-id="element-6901">
                    ✓
                  </div>
                  <p data-id="element-6902">Inter-House Sports Competition (November)</p>
                </li>
                <li className="flex items-start" data-id="element-6903">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-500 mr-2" data-id="element-6904">
                    ✓
                  </div>
                  <p data-id="element-6905">Founders' Day Sports Festival (February)</p>
                </li>
                <li className="flex items-start" data-id="element-6906">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-500 mr-2" data-id="element-6907">
                    ✓
                  </div>
                  <p data-id="element-6908">Swimming Gala (March)</p>
                </li>
                <li className="flex items-start" data-id="element-6909">
                  <div className="flex-shrink-0 h-5 w-5 text-yellow-500 mr-2" data-id="element-6910">
                    ✓
                  </div>
                  <p data-id="element-6911">Staff vs. Students Friendly Matches (End of Term)</p>
                </li>
              </ul>
            </div>
          </div>
        </section>
        {/* Events & Activities Section */}
        <section className="mb-16" id="events" data-id="element-6912">
          <div className="text-center mb-10" data-id="element-6913">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-6914">
              Events & Activities
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-6915"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-6916">
              Our calendar is filled with academic, cultural, and social events
              that enrich the student experience and create lasting memories.
            </p>
          </div>
          <Tabs tabs={[{
          id: 'upcoming',
          label: 'Upcoming Events',
          content: <div className="py-6" data-id="element-6918">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-6919">
                      {upcomingEvents.map((event, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-6920">
                          <div className="flex" data-id="element-6921">
                            <div className="mr-4" data-id="element-6922">
                              <div className="bg-blue-100 text-blue-900 font-bold rounded p-3 text-center min-w-[70px]" data-id="element-6923">
                                <div className="text-lg" data-id="element-6924">
                                  {event.date.split(',')[0].split(' ')[1]}
                                </div>
                                <div className="text-xs" data-id="element-6925">
                                  {event.date.split(',')[0].split(' ')[0].substring(0, 3).toUpperCase()}
                                </div>
                              </div>
                            </div>
                            <div data-id="element-6926">
                              <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-6927">
                                {event.name}
                              </h3>
                              <div className="flex items-center text-gray-600 mb-2" data-id="element-6928">
                                <ClockIcon className="h-4 w-4 mr-1" data-id="element-6929" />
                                <span className="text-sm" data-id="element-6930">{event.time}</span>
                                <span className="mx-2" data-id="element-6931">•</span>
                                <MapPinIcon className="h-4 w-4 mr-1" data-id="element-6932" />
                                <span className="text-sm" data-id="element-6933">
                                  {event.location}
                                </span>
                              </div>
                              <p className="text-gray-700" data-id="element-6934">
                                {event.description}
                              </p>
                            </div>
                          </div>
                        </div>)}
                    </div>
                    <div className="mt-8 text-center" data-id="element-6935">
                      <Button href="/events" variant="outline" icon={<ArrowRightIcon data-id="element-6937" />} iconPosition="right" data-id="element-6936">
                        View Full Events Calendar
                      </Button>
                    </div>
                  </div>
        }, {
          id: 'annual',
          label: 'Annual Traditions',
          content: <div className="py-6" data-id="element-6938">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-6939">
                      <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-6940">
                        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8M2i6Lt61u8AiKMZqhL6Xz/WhatsApp_Image_2025-10-24_at_10.01.22.jpg" alt="Cultural Day" className="w-full h-48 object-cover rounded-md mb-4" data-id="element-6941" />
                        <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-6942">
                          Cultural Day
                        </h3>
                        <p className="text-gray-700 mb-3" data-id="element-6943">
                          A colorful celebration of Nigeria's diverse cultures
                          featuring traditional dances, attire, and cuisine.
                          Students showcase their heritage and learn about other
                          cultures.
                        </p>
                        <div className="text-sm text-gray-600" data-id="element-6944">
                          <span className="font-medium" data-id="element-6945">When:</span> First week
                          of December
                        </div>
                      </div>
                      <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-6946">
                        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3DHAcubmTqmT13YpTTNQmr/WhatsApp_Image_2025-10-24_at_10.01.24.jpg" alt="Founders Day" className="w-full h-48 object-cover rounded-md mb-4" data-id="element-6947" />
                        <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-6948">
                          Founders' Day
                        </h3>
                        <p className="text-gray-700 mb-3" data-id="element-6949">
                          An annual commemoration of our school's founding,
                          featuring special assemblies, alumni visits, awards
                          ceremonies, and various competitions.
                        </p>
                        <div className="text-sm text-gray-600" data-id="element-6950">
                          <span className="font-medium" data-id="element-6951">When:</span> February
                          15th
                        </div>
                      </div>
                      <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-6952">
                        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5gKYWryVTvwM3jPw4Bpnok/WhatsApp_Image_2025-10-24_at_10.01.16.jpg" alt="Science Fair" className="w-full h-48 object-cover rounded-md mb-4" data-id="element-6953" />
                        <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-6954">
                          Science & Technology Fair
                        </h3>
                        <p className="text-gray-700 mb-3" data-id="element-6955">
                          Students showcase their innovative projects and
                          experiments in science, technology, engineering, and
                          mathematics. External judges evaluate the projects and
                          award prizes.
                        </p>
                        <div className="text-sm text-gray-600" data-id="element-6956">
                          <span className="font-medium" data-id="element-6957">When:</span> Second week
                          of February
                        </div>
                      </div>
                      <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-6958">
                        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bZLbes2hxk7MhXzaZ1hXLV/WhatsApp_Image_2025-10-24_at_10.01.19.jpg" alt="Inter-House Sports" className="w-full h-48 object-cover rounded-md mb-4" data-id="element-6959" />
                        <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-6960">
                          Inter-House Sports Competition
                        </h3>
                        <p className="text-gray-700 mb-3" data-id="element-6961">
                          A major highlight of the school calendar, featuring
                          track and field events, team sports, and individual
                          competitions. Houses compete for the coveted Champions
                          Trophy.
                        </p>
                        <div className="text-sm text-gray-600" data-id="element-6962">
                          <span className="font-medium" data-id="element-6963">When:</span> Second week
                          of November
                        </div>
                      </div>
                      <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-6964">
                        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jdfoyTCXLviMyjmi5MDX1X/WhatsApp_Image_2025-10-24_at_11.30.13.jpg" alt="Speech Day" className="w-full h-48 object-cover rounded-md mb-4" data-id="element-6965" />
                        <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-6966">
                          Speech & Prize-Giving Day
                        </h3>
                        <p className="text-gray-700 mb-3" data-id="element-6967">
                          An occasion to celebrate academic excellence and other
                          achievements. Awards are presented to outstanding
                          students, and graduating students receive their
                          certificates.
                        </p>
                        <div className="text-sm text-gray-600" data-id="element-6968">
                          <span className="font-medium" data-id="element-6969">When:</span> Last week
                          of the academic year
                        </div>
                      </div>
                      <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-6970">
                        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4bkQakMXE7oCJhU6DHfZ4v/WhatsApp_Image_2025-10-24_at_10.01.16_%281%29.jpg" alt="Career Day" className="w-full h-48 object-cover rounded-md mb-4" data-id="element-6971" />
                        <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-6972">
                          Career Exploration Day
                        </h3>
                        <p className="text-gray-700 mb-3" data-id="element-6973">
                          Professionals from various fields visit the school to
                          share insights about their careers. Students get to
                          ask questions and learn about different career paths.
                        </p>
                        <div className="text-sm text-gray-600" data-id="element-6974">
                          <span className="font-medium" data-id="element-6975">When:</span> First week
                          of May
                        </div>
                      </div>
                    </div>
                  </div>
        }, {
          id: 'clubs',
          label: 'Clubs & Societies',
          content: <div className="py-6" data-id="element-6976">
                    <p className="text-gray-700 mb-6" data-id="element-6977">
                      Our clubs and societies provide platforms for students to
                      explore their interests, develop skills, and build
                      relationships outside the classroom. Each club is
                      supervised by a staff advisor who provides guidance and
                      support.
                    </p>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-6978">
                      <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-6979">
                        <div className="flex items-center mb-4" data-id="element-6980">
                          <div className="p-3 bg-blue-100 rounded-full mr-3" data-id="element-6981">
                            <CpuIcon className="h-6 w-6 text-blue-700" data-id="element-6982" />
                          </div>
                          <h3 className="text-lg font-bold text-blue-900" data-id="element-6983">
                            Science & Technology Club
                          </h3>
                        </div>
                        <p className="text-gray-700 mb-3" data-id="element-6984">
                          For students passionate about science and technology.
                          Activities include experiments, robotics, coding, and
                          preparation for science competitions.
                        </p>
                        <div className="text-sm text-gray-600" data-id="element-6985">
                          <span className="font-medium" data-id="element-6986">Meeting Day:</span>{' '}
                          Tuesdays
                        </div>
                      </div>
                      <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-6987">
                        <div className="flex items-center mb-4" data-id="element-6988">
                          <div className="p-3 bg-blue-100 rounded-full mr-3" data-id="element-6989">
                            <MessageSquareIcon className="h-6 w-6 text-blue-700" data-id="element-6990" />
                          </div>
                          <h3 className="text-lg font-bold text-blue-900" data-id="element-6991">
                            Literary & Debating Society
                          </h3>
                        </div>
                        <p className="text-gray-700 mb-3" data-id="element-6992">
                          Focuses on developing public speaking, critical
                          thinking, and argumentation skills. Members
                          participate in debates, public speaking contests, and
                          model UN conferences.
                        </p>
                        <div className="text-sm text-gray-600" data-id="element-6993">
                          <span className="font-medium" data-id="element-6994">Meeting Day:</span>{' '}
                          Wednesdays
                        </div>
                      </div>
                      <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-6995">
                        <div className="flex items-center mb-4" data-id="element-6996">
                          <div className="p-3 bg-blue-100 rounded-full mr-3" data-id="element-6997">
                            <PaletteIcon className="h-6 w-6 text-blue-700" data-id="element-6998" />
                          </div>
                          <h3 className="text-lg font-bold text-blue-900" data-id="element-6999">
                            Art & Photography Club
                          </h3>
                        </div>
                        <p className="text-gray-700 mb-3" data-id="element-7000">
                          For creative students interested in visual arts.
                          Activities include drawing, painting, sculpture,
                          photography, and organizing art exhibitions.
                        </p>
                        <div className="text-sm text-gray-600" data-id="element-7001">
                          <span className="font-medium" data-id="element-7002">Meeting Day:</span>{' '}
                          Thursdays
                        </div>
                      </div>
                      <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-7003">
                        <div className="flex items-center mb-4" data-id="element-7004">
                          <div className="p-3 bg-blue-100 rounded-full mr-3" data-id="element-7005">
                            <MusicIcon className="h-6 w-6 text-blue-700" data-id="element-7006" />
                          </div>
                          <h3 className="text-lg font-bold text-blue-900" data-id="element-7007">
                            Music & Drama Club
                          </h3>
                        </div>
                        <p className="text-gray-700 mb-3" data-id="element-7008">
                          For students interested in performing arts. Members
                          learn to play instruments, sing, act, and participate
                          in school productions and competitions.
                        </p>
                        <div className="text-sm text-gray-600" data-id="element-7009">
                          <span className="font-medium" data-id="element-7010">Meeting Day:</span>{' '}
                          Fridays
                        </div>
                      </div>
                      <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-7011">
                        <div className="flex items-center mb-4" data-id="element-7012">
                          <div className="p-3 bg-blue-100 rounded-full mr-3" data-id="element-7013">
                            <GlobeIcon className="h-6 w-6 text-blue-700" data-id="element-7014" />
                          </div>
                          <h3 className="text-lg font-bold text-blue-900" data-id="element-7015">
                            Environmental Club
                          </h3>
                        </div>
                        <p className="text-gray-700 mb-3" data-id="element-7016">
                          Focuses on environmental conservation and
                          sustainability. Activities include tree planting,
                          recycling initiatives, and awareness campaigns.
                        </p>
                        <div className="text-sm text-gray-600" data-id="element-7017">
                          <span className="font-medium" data-id="element-7018">Meeting Day:</span>{' '}
                          Mondays
                        </div>
                      </div>
                      <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-7019">
                        <div className="flex items-center mb-4" data-id="element-7020">
                          <div className="p-3 bg-blue-100 rounded-full mr-3" data-id="element-7021">
                            <CpuIcon className="h-6 w-6 text-blue-700" data-id="element-7022" />
                          </div>
                          <h3 className="text-lg font-bold text-blue-900" data-id="element-7023">
                            Robotics Club
                          </h3>
                        </div>
                        <p className="text-gray-700 mb-3" data-id="element-7024">
                          For students interested in robotics and engineering.
                          Members learn to design, build, and program robots,
                          and participate in robotics competitions.
                        </p>
                        <div className="text-sm text-gray-600" data-id="element-7025">
                          <span className="font-medium" data-id="element-7026">Meeting Day:</span>{' '}
                          Tuesdays
                        </div>
                      </div>
                    </div>
                    <div className="mt-8 text-center" data-id="element-7027">
                      <Button href="/student-life/clubs" variant="outline" icon={<ArrowRightIcon data-id="element-7029" />} iconPosition="right" data-id="element-7028">
                        Explore All Clubs & Societies
                      </Button>
                    </div>
                  </div>
        }]} variant="pills" className="mb-8" data-id="element-6917" />
        </section>
        {/* Testimonials Section */}
        <section id="testimonials" data-id="element-7030">
          <div className="text-center mb-10" data-id="element-7031">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-7032">
              Student & Parent Testimonials
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-7033"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-7034">
              Hear from our students and parents about their experiences at
              Isonyin Grammar School.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-7035">
            {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-8 rounded-lg shadow-md relative" data-id="element-7036">
                <div className="absolute -top-4 -left-4 text-6xl text-yellow-500 opacity-30" data-id="element-7037">
                  "
                </div>
                <div className="relative z-10" data-id="element-7038">
                  <p className="text-gray-700 italic mb-6 leading-relaxed" data-id="element-7039">
                    {testimonial.quote}
                  </p>
                  <div className="flex items-center" data-id="element-7040">
                    <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover mr-4" data-id="element-7041" />
                    <div data-id="element-7042">
                      <h4 className="font-bold text-blue-900" data-id="element-7043">
                        {testimonial.name}
                      </h4>
                      <p className="text-sm text-gray-500" data-id="element-7044">
                        {testimonial.role}
                      </p>
                    </div>
                  </div>
                </div>
              </div>)}
          </div>
          <div className="mt-12 bg-blue-900 text-white p-8 rounded-lg text-center" data-id="element-7045">
            <h3 className="text-2xl font-bold mb-4" data-id="element-7046">
              Experience Isonyin Grammar School
            </h3>
            <p className="mb-6 max-w-2xl mx-auto" data-id="element-7047">
              Join our community of learners and future leaders. Discover the
              IGS difference through our holistic approach to education that
              nurtures academic excellence, character development, and talent
              discovery.
            </p>
            <div className="flex flex-wrap justify-center gap-4" data-id="element-7048">
              <Button href="/admissions" variant="primary" size="lg" animation="scale" data-id="element-7049">
                Apply for Admission
              </Button>
              <Button href="/virtual-tour" variant="outline" size="lg" className="border-white text-white hover:bg-white/10" data-id="element-7050">
                Take a Virtual Tour
              </Button>
            </div>
          </div>
        </section>
      </div>
    </div>;
};
export default memo(StudentLife);